/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import styled from 'styled-components';
import { NavLink, useNavigate, Link } from 'react-router-dom';
import { FiExternalLink } from 'react-icons/fi';
import { MdOutlineSpaceDashboard } from 'react-icons/md';
import { BsChevronDoubleLeft } from 'react-icons/bs';
import { AiOutlineDoubleRight, AiOutlineCreditCard } from 'react-icons/ai';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';
import { IoChatboxEllipsesOutline, IoMapOutline } from 'react-icons/io5';

import { getPublicAssetPath } from '../../../shared/config/publicAssetPath';

import type { Dispatch, SetStateAction } from 'react';

const Sidebar = (props: {
  sideBarClose: boolean;
  sideBarDisplay: string;
  setSideBarClose: Dispatch<SetStateAction<boolean>>;
  setSideBarDisplay: Dispatch<SetStateAction<string>>;
}) => {
  const navigate = useNavigate();

  // 토글 리스트 타입 인터페이스
  interface IToggleList {
    entityManagement: boolean;
    deviceManagement: boolean;
    edgecrossService: boolean;
    datapointService: boolean;
    prodoqService: boolean;
    progixService: boolean;
    scautrService: boolean;
    anchor: boolean;
  }

  const [toggleList, setToggleList] = useState<IToggleList>({
    entityManagement: false,
    deviceManagement: false,
    edgecrossService: false,
    datapointService: false,
    prodoqService: false,
    progixService: false,
    scautrService: false,
    anchor: false,
  });

  return (
    <Wrap sideBarClose={props.sideBarClose} sideBarDisplay={props.sideBarDisplay}>
      {/* 상단 로고 타이틀 */}
      <Title sideBarClose={props.sideBarClose}>
        {/* --------- 사이드바 열기 --------- */}
        <AiOutlineDoubleRight
          onClick={() => {
            props.setSideBarClose(!props.sideBarClose);
          }}
        />
        <img
          src={getPublicAssetPath('/images/side_bar_logo.png')}
          alt="엣지크로스 로고"
          onClick={() => {
            navigate('/admin/management/device');
          }}
        />
      </Title>
      {/* 타이틀 하단 메뉴바 */}
      <Navbar sideBarClose={props.sideBarClose} toggleList={toggleList}>
        <div className="menu-title">
          <span>관리자 메뉴</span>
          {/* --------- 사이드바 접기 --------- */}
          {/* 모바일 크기일 때, 사이드바 display block & none */}
          <div className="mobile">
            <BsChevronDoubleLeft
              onClick={() => {
                props.setSideBarDisplay('none');
              }}
            />
          </div>
          {/* 모바일 크기가 아닐 때, 사이드바 열고 접기 */}
          <div className="desktop">
            <BsChevronDoubleLeft
              onClick={() => {
                props.setSideBarClose(!props.sideBarClose);
                setToggleList({
                  entityManagement: false,
                  edgecrossService: false,
                  datapointService: false,
                  prodoqService: false,
                  progixService: false,
                  scautrService: false,
                  deviceManagement: false,
                  anchor: false,
                });
              }}
            />
          </div>
        </div>
        <ul>
          {/* --------- li --------- */}
          <li
            onClick={() => {
              setToggleList((prev) => {
                let newToogleList: IToggleList = { ...prev };
                newToogleList['entityManagement'] = !newToogleList['entityManagement'];
                return newToogleList;
              });
            }}
          >
            <Link to="#" onClick={(e) => e.preventDefault()}>
              <div className="svg-box">
                <MdOutlineSpaceDashboard />
              </div>
              <div className="menu-toggle">
                <span>통합 관리</span>
                {toggleList.entityManagement ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
              </div>
            </Link>
          </li>
          {/* --------- li toggle box--------- */}
          <div className="menu-toggle-box-entityManagement">
            <NavLink to="/admin/management/company">
              <span>거래처</span>
            </NavLink>
            <NavLink to="/admin/management/device">
              <span>디바이스</span>
            </NavLink>
            <NavLink to="/admin/management/modem">
              <span>모뎀</span>
            </NavLink>
            <NavLink to="/admin/management/plan">
              <span>요금제 생성/관리</span>
            </NavLink>
            <NavLink to="/admin/management/dispatch/eptp">
              <span>출고관리(EP/TP)</span>
            </NavLink>
            <NavLink to="/admin/management/dispatch/manufacturer">
              <span>출고관리(기계 제조사)</span>
            </NavLink>
            <NavLink to="/admin/management/dispatch/end-user">
              <span>출고관리(실사용자)</span>
            </NavLink>
            <NavLink to="/admin/management/aiagent/company">
              <span>AI Agent 서비스 관리</span>
            </NavLink>
            {/* <NavLink to="/admin/management/model">
              <span>기계모델 정보</span>
            </NavLink> */}
          </div>
          {/* --------- li --------- */}
          <li
            onClick={() => {
              setToggleList((prev) => {
                let newToogleList: IToggleList = { ...prev };
                newToogleList['prodoqService'] = !newToogleList['prodoqService'];
                return newToogleList;
              });
            }}
          >
            <Link to="#" onClick={(e) => e.preventDefault()}>
              <div className="svg-box">
                <IoChatboxEllipsesOutline />
              </div>
              <div className="menu-toggle">
                <span>PRO-DOQ</span>
                {toggleList.prodoqService ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
              </div>
            </Link>
          </li>
          {/* --------- li toggle box--------- */}
          <div className="menu-toggle-box-prodoq">
            <NavLink to="/admin/prodoq/role">
              <span>역할 및 권한 설정</span>
            </NavLink>
          </div>
          {/* --------- li --------- */}
          {/* <li
            onClick={() => {
              setToggleList((prev) => {
                let newToogleList: IToggleList = { ...prev };
                newToogleList['prodoqService'] = !newToogleList['prodoqService'];
                return newToogleList;
              });
            }}
          >
            <Link to="#" onClick={(e) => e.preventDefault()}>
              <div className="svg-box">
                <IoChatboxEllipsesOutline />
              </div>
              <div className="menu-toggle">
                <span>PRO-DOQ</span>
                {toggleList.prodoqService ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
              </div>
            </Link>
          </li> */}
          {/* --------- li toggle box--------- */}
          {/* <div className="menu-toggle-box-prodoq">
            <NavLink to="/admin/prodoq/member">
              <span>유저 관리</span>
            </NavLink>
          </div> */}
          {/* --------- li --------- */}
          {/* <li
            onClick={() => {
              setToggleList((prev) => {
                let newToogleList: IToggleList = { ...prev };
                newToogleList['progixService'] = !newToogleList['progixService'];
                return newToogleList;
              });
            }}
          >
            <Link to="#" onClick={(e) => e.preventDefault()}>
              <div className="svg-box">
                <MdOutlineManageAccounts />
              </div>
              <div className="menu-toggle">
                <span>프로직스</span>
                {toggleList.progixService ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
              </div>
            </Link>
          </li> */}
          {/* --------- li toggle box--------- */}
          <div className="menu-toggle-box-progix">
            {/* <NavLink to="/admin/progix/deviceService">
              <span>디바이스 서비스 정보 등록</span>
            </NavLink> */}
            <NavLink to="/admin/progix/payment">
              <span>결제내역</span>
            </NavLink>
            <NavLink to="/admin/progix/refund">
              <span>환불요청</span>
            </NavLink>
            <NavLink to="/admin/progix/refund-success">
              <span>환불내역</span>
            </NavLink>
          </div>
          {/* --------- li --------- */}
          <li
            onClick={() => {
              setToggleList((prev) => {
                let newToogleList: IToggleList = { ...prev };
                newToogleList['datapointService'] = !newToogleList['datapointService'];
                return newToogleList;
              });
            }}
          >
            <Link to="#" onClick={(e) => e.preventDefault()}>
              <div className="svg-box">
                <AiOutlineCreditCard />
              </div>
              <div className="menu-toggle">
                <span>릴레이 포인트</span>
                {toggleList.datapointService ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
              </div>
            </Link>
          </li>
          {/* --------- li toggle box--------- */}
          <div className="menu-toggle-box-datapoint">
            <NavLink to="/admin/datapoint/member">
              <span>회원관리</span>
            </NavLink>
            <NavLink to="/admin/datapoint/payment">
              <span>결제내역</span>
            </NavLink>
            <NavLink to="/admin/datapoint/refund">
              <span>환불요청</span>
            </NavLink>
            <NavLink to="/admin/datapoint/refund-success">
              <span>환불내역</span>
            </NavLink>
          </div>
          {/* --------- li --------- */}
          <li
            onClick={() => {
              setToggleList((prev) => {
                let newToogleList: IToggleList = { ...prev };
                newToogleList['edgecrossService'] = !newToogleList['edgecrossService'];
                return newToogleList;
              });
            }}
          >
            <Link to="#" onClick={(e) => e.preventDefault()}>
              <div className="svg-box">
                <IoMapOutline />
              </div>
              <div className="menu-toggle">
                <span>사업 / 운영</span>
                {toggleList.edgecrossService ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
              </div>
            </Link>
          </li>
          {/* --------- li toggle box--------- */}
          <div className="menu-toggle-box-edgecross-service">
            <NavLink to="/admin/edgecross/brochure">
              <span>제품 소개서 신청 현황</span>
            </NavLink>
            <NavLink to="/admin/edgecross/notice">
              <span>공지사항</span>
            </NavLink>
          </div>
          {/* --------- li --------- */}
          <li
            onClick={() => {
              setToggleList((prev) => {
                let newToogleList: IToggleList = { ...prev };
                newToogleList['anchor'] = !newToogleList['anchor'];
                return newToogleList;
              });
            }}
          >
            <Link to="#" onClick={(e) => e.preventDefault()}>
              <div className="svg-box">
                <FiExternalLink />
              </div>
              <div className="menu-toggle">
                <span>서비스 바로가기</span>
                {toggleList.anchor ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
              </div>
            </Link>
          </li>
          {/* --------- li toggle box--------- */}
          <div className="menu-toggle-box-anchor">
            <a href="https://scautr.edgecross.ai/" target="_blank" rel="noreferrer">
              <span>스카우터 바로가기</span>
            </a>
            <a href="https://progix.edgecross.ai/" target="_blank" rel="noreferrer">
              <span>프로직스 바로가기</span>
            </a>
            <a href="https://relaypoint.edgecross.ai/" target="_blank" rel="noreferrer">
              <span>릴레이포인트 바로가기</span>
            </a>
            <a href="https://www.v-ola.com/auth/login.do?returnto=/" target="_blank" rel="noreferrer">
              <span>V-OLA 바로가기</span>
            </a>
          </div>
        </ul>
      </Navbar>
    </Wrap>
  );
};

export default Sidebar;

const Wrap = styled.div`
  position: fixed;
  z-index: 10;
  /* 사이드바 닫기 클릭 여부에 따라서 width 조정 */
  width: ${(props: { sideBarClose: boolean }) => (props.sideBarClose ? '60px' : '230px')};
  overflow-x: hidden;
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
  height: 100dvh;
  background-color: ${(props) => props.theme.color.bg[600]};
  color: ${(props) => props.theme.color.white};
  font-size: 14px;
  /* (반응형) 570px 보다 낮은 화면에서는 사이드바가 none */
  @media (max-width: ${(props) => props.theme.breakpoints.Mobile}) {
    display: ${(props: { sideBarClose: boolean; sideBarDisplay: string }) => props.sideBarDisplay};
  }
  overflow-y: auto;
`;

const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  height: 115px;
  img {
    width: 200px;
    cursor: pointer;
    display: ${(props: { sideBarClose: boolean }) => (props.sideBarClose ? 'none' : 'inline')};
  }
  svg {
    cursor: pointer;
    font-size: 20px;
    display: ${(props: { sideBarClose: boolean }) => (props.sideBarClose ? 'block' : 'none')};
  }
`;
const Navbar = styled.nav`
  margin-top: 20px;
  padding-bottom: 20px;
  .menu-title {
    color: ${(props) => props.theme.color.gray};
    padding: 10px;
    padding-right: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:hover {
      svg {
        color: ${(props) => props.theme.color.white};
      }
    }
    svg {
      cursor: pointer;
    }
    visibility: ${(props: { sideBarClose: boolean }) => (props.sideBarClose ? 'hidden' : 'visible')};
  }
  .mobile {
    @media (min-width: ${(props) => props.theme.breakpoints.Mobile}) {
      display: none;
    }
  }
  .desktop {
    @media (max-width: ${(props) => props.theme.breakpoints.Mobile}) {
      display: none;
    }
  }
  ul {
    list-style: none;
    li {
      cursor: pointer;
      svg {
        color: ${(props) => props.theme.color.gray};
        font-size: 20px;
      }
      &:hover {
        background-color: #222;
        svg {
          color: ${(props) => props.theme.color.white};
        }
      }
      .svg-box {
        margin-right: 20px;
      }
      .menu-toggle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }
      a {
        display: flex;
        align-items: center;
        padding: 15px;
        padding-left: 20px;
        padding-right: 20px;
        width: 100%;
        &.active {
          background-color: ${(props) => props.theme.color.blue};
          svg {
            color: ${(props) => props.theme.color.white};
          }
        }
      }
    }
    .menu-toggle-box-datapoint {
      transition: all 0.2s ease-in-out;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      max-height: ${(props: { sideBarClose: boolean; toggleList: any }) => (props.toggleList.datapointService ? '1000px' : '0')};
      a {
        padding: 10px;
        color: #ccc;
        span {
          padding-left: 50px;
        }
        &:hover {
          background-color: #222;
        }
        &.active {
          background-color: ${(props) => props.theme.color.blue};
          color: ${(props) => props.theme.color.white};
        }
      }
    }
    .menu-toggle-box-edgecross-service {
      transition: all 0.2s ease-in-out;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      max-height: ${(props: { sideBarClose: boolean; toggleList: any }) => (props.toggleList.edgecrossService ? '1000px' : '0')};
      a {
        padding: 10px;
        color: #ccc;
        span {
          padding-left: 50px;
        }
        &:hover {
          background-color: #222;
        }
        &.active {
          background-color: ${(props) => props.theme.color.blue};
          color: ${(props) => props.theme.color.white};
        }
      }
    }
    .menu-toggle-box-prodoq {
      transition: all 0.2s ease-in-out;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      max-height: ${(props: { sideBarClose: boolean; toggleList: any }) => (props.toggleList.prodoqService ? '1000px' : '0')};
      a {
        padding: 10px;
        color: #ccc;
        span {
          padding-left: 50px;
        }
        &:hover {
          background-color: #222;
        }
        &.active {
          background-color: ${(props) => props.theme.color.blue};
          color: ${(props) => props.theme.color.white};
        }
      }
    }
    .menu-toggle-box-progix {
      transition: all 0.2s ease-in-out;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      max-height: ${(props: { sideBarClose: boolean; toggleList: any }) => (props.toggleList.progixService ? '1000px' : '0')};
      a {
        padding: 10px;
        color: #ccc;
        span {
          padding-left: 50px;
        }
        &:hover {
          background-color: #222;
        }
        &.active {
          background-color: ${(props) => props.theme.color.blue};
          color: ${(props) => props.theme.color.white};
        }
      }
    }
    .menu-toggle-box-deviceManagement {
      transition: all 0.2s ease-in-out;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      max-height: ${(props: { sideBarClose: boolean; toggleList: any }) => (props.toggleList.deviceManagement ? '1000px' : '0')};
      a {
        padding: 10px;
        color: #ccc;
        span {
          padding-left: 50px;
        }
        &:hover {
          background-color: #222;
        }
        &.active {
          background-color: ${(props) => props.theme.color.blue};
          color: ${(props) => props.theme.color.white};
        }
      }
    }

    .menu-toggle-box-scautr {
      transition: all 0.2s ease-in-out;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      max-height: ${(props: { sideBarClose: boolean; toggleList: any }) => (props.toggleList.scautrService ? '1000px' : '0')};
      a {
        padding: 10px;
        color: #ccc;
        span {
          padding-left: 50px;
        }
        &:hover {
          background-color: #222;
        }
        &.active {
          background-color: ${(props) => props.theme.color.blue};
          color: ${(props) => props.theme.color.white};
        }
      }
    }

    .menu-toggle-box-entityManagement {
      transition: all 0.2s ease-in-out;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      max-height: ${(props: { sideBarClose: boolean; toggleList: any }) => (props.toggleList.entityManagement ? '1000px' : '0')};
      a {
        padding: 10px;
        color: #ccc;
        span {
          padding-left: 50px;
        }
        &:hover {
          background-color: #222;
        }
        &.active {
          background-color: ${(props) => props.theme.color.blue};
          color: ${(props) => props.theme.color.white};
        }
      }
    }

    .menu-toggle-box-anchor {
      transition: all 0.2s ease-in-out;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      max-height: ${(props: { sideBarClose: boolean; toggleList: any }) => (props.toggleList.anchor ? '1000px' : '0')};
      a {
        padding: 10px;
        color: #ccc;
        span {
          padding-left: 50px;
        }
        &:hover {
          background-color: #222;
        }
        &.active {
          background-color: ${(props) => props.theme.color.blue};
          color: ${(props) => props.theme.color.white};
        }
      }
    }
  }
`;
